"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Checks if it is an automation account based on browser cookies
 *
 * @returns {boolean} - `true` if the "is-automation-account" cookie is set to "true", otherwise `false`.
 */
var isAutomation = function isAutomation() {
  return document.cookie.split('; ').some(function (cookie) {
    return cookie === 'is-automation-account=true';
  });
};
var _default = exports["default"] = isAutomation;